export default "__VITE_ASSET__D6w5gL8s__"